'use strict';
function doughQuantities(v) {
  const total = v.flour + v.water + v.starter + v.salt + v.other;
  return { total, perLoaf: total / v.loaves };
}
function brewQuantities(v) {
  return { dose: v.dose * v.servings, water: Math.round(v.dose * v.ratio * v.servings * 1e6) / 1e6, milk: v.milk * v.servings };
}
if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-calculator]').forEach((root) => {
    const form = root.querySelector('form');
    const result = root.querySelector('[data-result]');
    const explanation = root.querySelector('[data-explanation]');
    const error = root.querySelector('[data-error]');
    const format = (n) => new Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 }).format(n);
    const update = () => {
      const valid = form.checkValidity();
      error.hidden = valid;
      if (!valid) { result.textContent = 'Check your quantities'; explanation.textContent = 'The calculator needs valid amounts before it can give a result.'; return; }
      const v = Object.fromEntries([...new FormData(form)].map(([k, value]) => [k, k === 'mode' ? value : Number(value)]));
      if (root.dataset.calculator === 'dough') {
        const q = doughQuantities(v);
        result.textContent = `${format(q.perLoaf)} g per loaf`;
        explanation.textContent = `Total dough: ${format(q.total)} g. ` + (v.capacity ? (q.perLoaf > v.capacity ? `This exceeds the stated ${format(v.capacity)} g basket rating. Divide into more loaves or choose a basket rated for this weight.` : `This is within the stated ${format(v.capacity)} g rating. Allow for the maker's guidance on dough type and rise.`) : "Compare this with the basket maker's dough-weight rating. Dimensions alone cannot confirm capacity.");
      } else {
        const q = brewQuantities(v);
        const coffee = v.mode === 'coffee';
        result.textContent = `${format(q.dose)} g ${coffee ? 'coffee' : 'matcha'} + ${format(q.water)} ${coffee ? 'g' : 'ml'} water${v.mode === 'latte' ? ` + ${format(q.milk)} ml milk` : ''}`;
        explanation.textContent = coffee ? 'Water is the amount poured into the brewer. The cup will contain less because the grounds retain water.' : v.mode === 'latte' ? 'Based on an adjustable 3 g matcha, 100 ml water and 100 ml milk per serving. Allow room in the cup for foam.' : 'Based on an adjustable 2 g matcha and 60 ml water per serving. Follow the tea producer’s brewing instructions.';
        const link = root.querySelector('[data-shop-link]');
        link.href = coffee ? '/collections/coffee' : '/collections/matcha';
        link.textContent = coffee ? 'Explore coffee tools' : 'Explore matcha tools';
      }
    };
    form.addEventListener('submit', (event) => event.preventDefault());
    form.addEventListener('input', update);
    form.elements.mode?.addEventListener('change', () => {
      const mode = form.elements.mode.value;
      form.elements.dose.value = mode === 'coffee' ? 15 : mode === 'matcha' ? 2 : 3;
      form.elements.ratio.value = mode === 'coffee' ? 16.6667 : mode === 'matcha' ? 30 : 33.3333;
      root.querySelector('[data-dose-label]').textContent = mode === 'coffee' ? 'Coffee per serving (g)' : 'Matcha per serving (g)';
      root.querySelector('[data-ratio-label]').textContent = mode === 'coffee' ? 'Water per gram of coffee (g)' : 'Water per gram of matcha (ml)';
      root.querySelector('[data-milk-field]').hidden = mode !== 'latte';
      update();
    });
    update();
  });
}
if (typeof module !== 'undefined') module.exports = { doughQuantities, brewQuantities };
